import isComplete from './isComplete';
import { INVALID } from '../constants/orders';

export const canUpload = ({ status }) => 
  !isComplete(status) && status !== INVALID;

export default canUpload;
